import { noop } from 'lodash';
import '../base/legacy';
import './legacy';
import './mounts';
import { initIntercom } from './react/services/Intercom';
import { initPerformanceTracking } from './react/services/PerformanceTracking';
import { initPostHog } from './react/services/PostHog';
import { getTracking, trackEvent } from './react/services/Tracking';
import init from './render';

initPerformanceTracking((loadTimeMs, initialLoad) => {
    trackEvent({
        category: 'SYSTEM',
        action: 'measure load time',
        label: `Performance Metrics (${initialLoad ? 'initial load' : 'spa'})`,
        value: Math.round(loadTimeMs),
        nonInteractive: true,
    });
});
getTracking().catch(noop);

if (module.hot) {
    module.hot.decline();
}

init();
initIntercom();
initPostHog();
